// extracted by mini-css-extract-plugin
module.exports =  {"status":"_7a3fb80146--status--laM86","red":"_7a3fb80146--red--N95RP","green":"_7a3fb80146--green--OoKyw"};